export default {
    title: 'Ordini',
    icon: 'mdi-newspaper-variant-multiple',
    groups: ['Amministrazione', 'Schedulazione', 'Magazzino'],
    divider: true,
    submenu: [
        {
            title: 'Dashboard',
            route: {name: 'ordini-dashboard'},
            users: ['riccardo'],
        },
        {
            title: 'Ordini Vendita',
            route: {name: 'ordini-clienti-aperti'},
            groups: ['Amministrazione', 'Schedulazione', 'Magazzino']
        },
        {
            title: 'Proposte',
            route: {name: 'ordini-proposte'},
            badge: {url: '/ordini/proposte/?conteggio=true', tooltip: 'Conteggio Offerte'},
            groups: ['Amministrazione', 'Schedulazione']
        },
        {
            title: 'Offerte',
            route: {name: 'ordini-offerte'},
            badge: {url: '/ordini/offerte/?conteggio=true', tooltip: 'Conteggio Offerte'},
            groups: ['Amministrazione', 'Schedulazione']
        },
        {
            title: 'Cicli da disegno V2',
            route: {name: 'ordini-proposte-v2'},
            badge: {url: '/ordini/proposte-v2/?conteggio=true', tooltip: 'Cicli da completare'},
            groups: ['Amministrazione', 'Schedulazione']
        },
        {
            title: 'Inserimento Ordine',
            route: {name: 'ordini-clienti'},
            groups: ['Amministrazione', 'Schedulazione']
        },
    ]
}
